var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "6" } },
        [
          _c("app-color-picker", {
            attrs: {
              color: _vm.value.Style.BackgroundColor,
              label: _vm.$ct("backgroundColor"),
              fancy: "",
            },
            on: {
              input: function ($event) {
                _vm.value.Style.BackgroundColor = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "6" } },
        [
          _c("app-color-picker", {
            attrs: {
              color: _vm.value.Style.Color,
              label: _vm.$ct("textColor"),
              fancy: "",
            },
            on: {
              input: function ($event) {
                _vm.value.Style.Color = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }